import NotificationsWatchNow from './NotificationsWatchNow'

export default NotificationsWatchNow
// eslint-disable-next-line import/export
export * from './NotificationsWatchNow'
